import React, { Component, Fragment } from "react";

import Select from "react-select";
import "./ProductAttribute.css";

import { isFloat, required, length } from "../../../util/validators";

const origin = [
  { value: "1", label: "دارد" },
  { value: "0", label: "ندارد" },
];

const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: "white" }),
  theme: (styles) => ({ ...styles, borderRadius: "8px" }),
};

class ProductAttribute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formIsValid: true,
      productAttributes: [],
      productAttributesCount: 0,          

      attributeForm: {
        product_length: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isFloat],
        },
        product_width: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isFloat],
        },
        product_height: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isFloat],
        },
        product_weight: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isFloat],
        },
      },
    };

    this.productAttributeFormHandler = this.productAttributeFormHandler.bind(this);
    this.inputSelectChangeHandler = this.inputSelectChangeHandler.bind(this);
    this.inputChangeHandler = this.inputChangeHandler.bind(this);
  }

  ////////////////////////////////////////////////////////////////////////////////////////

  componentDidUpdate(previousProps, previousState) {
    if (previousProps.categoryData !== this.props.categoryData) {
      this.fetchProductAttributes(this.props.categoryData.code);
      this.countProductAttributes(this.props.categoryData.code);


      

      this.setState((prevState) => {
        let updatedForm = { ...prevState.attributeForm };

        for (const inputName in prevState.attributeForm) {
                
          updatedForm = {
            ...updatedForm,
            [inputName]: {
              ...updatedForm[inputName],
              value: this.props.productSize[inputName],
              valid: true,
            },
          };
        }

        return {
          attributeForm: updatedForm,
        };
      });

    }
  }

  handleValidation() {
    if (this.state.formIsValid) {
      return true;
    }

    this.setState((prevState) => {
      let updatedForm = { ...prevState.attributeForm };
      for (const inputName in prevState.attributeForm) {
        let isValid = true;
        let errorMessage = "";
        // if (prevState.attributeForm[inputName].value !== "string") {
        if (Array.isArray(prevState.attributeForm[inputName].value)) {
          for (const validator of prevState.attributeForm[inputName].validators) {
            isValid =
              isValid &&
              validator(prevState.attributeForm[inputName].value[0].value).hasError;
            errorMessage =
              !isValid && errorMessage === ""
                ? validator(prevState.attributeForm[inputName].value[0].value)
                    .errorMessage
                : errorMessage;
          }
        } else {
          // console.log(2);
          // console.log(inputName);
          for (const validator of prevState.attributeForm[inputName].validators) {
            isValid =
              isValid &&
              validator(prevState.attributeForm[inputName].value).hasError;
            errorMessage =
              !isValid && errorMessage === ""
                ? validator(prevState.attributeForm[inputName].value).errorMessage
                : errorMessage;
          }
        }
        updatedForm = {
          ...updatedForm,
          [inputName]: {
            ...updatedForm[inputName],
            valid: isValid,
            errorMessage: errorMessage,
          },
        };
      }
      return {
        attributeForm: updatedForm,
      };
    });
  }

  productAttributeFormHandler() {
    if (this.handleValidation()) {
      var productAttributes=[];
      for (const data in this.state.attributeForm) {
        if (data !== "product_length" && data !== "product_width" && data !== "product_height" && data !== "product_weight" ) {
          var Form = new Object();
          // console.log(data);
          // console.log(this.state.attributeForm[data]);
          if(this.state.attributeForm[data].validators.length===0 && this.state.attributeForm[data].value.length===0){
            Form.value=[];
          } else {
            if (this.state.attributeForm[data].attributeTypeId<3) {            
              Form.value= [this.state.attributeForm[data].value];
            }else if(this.state.attributeForm[data].attributeTypeId==3) {
              Form.value= [this.state.attributeForm[data].value];
            }else if(this.state.attributeForm[data].attributeTypeId==4) {
              // console.log(data);
              // console.log(this.state.attributeForm[data]);
              Form.value= [this.state.attributeForm[data].value.value.toString()];
            }else{
              Form.value= this.state.attributeForm[data].value.map(data => data.value.toString());
            }
          }
          Form.code= this.state.attributeForm[data].code;
          Form.attributeTypeId= this.state.attributeForm[data].attributeTypeId;
          productAttributes.push(Form);
        }
      }

      var postProductAttribute = {
        product_length: this.state.attributeForm.product_length.value,
        product_width: this.state.attributeForm.product_width.value,
        product_height: this.state.attributeForm.product_height.value,
        product_weight: this.state.attributeForm.product_weight.value,

        productAttributes: productAttributes,
      };

    // if (1) {
      this.props.addProductAttributeHandler(postProductAttribute);
    }
    else {
      console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
    }
  };


  countProductAttributes = (code) => {
    const graphqlQuery = {
      query: `
            query FetchProductAttributes($categoryCode: Int) {
              countProductAttributes(categoryCode: $categoryCode){
                count
              }
            }
          `,
      variables: {
        categoryCode: code,
      },
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {   
        if (resData.errors) {
          throw new Error("مشکل در دریافت ویژگی‌ها!");
        }
        this.setState({
          productAttributesCount: resData.data.countProductAttributes.count,
        });
      })
      .catch(this.catchError);
  };

  

  fetchProductAttributes = (code) => {
    const graphqlQuery = {
      query: `
            query FetchProductAttributes($categoryCode: Int) {
              productAttributes(categoryCode: $categoryCode){
                code
                title
                specifications{
                  code
                  title
                  attributeTypeId
                  isRequire
                  unit
                  items{
                    code
                    title
                  }
                }
              }
            }
          `,
      variables: {
        categoryCode: code,
      },
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        // console.log(resData);
        if (resData.errors) {
          throw new Error("مشکل در دریافت ویژگی‌ها!");
        }
        // let count=0;
        // const result= resData.data.productAttributes.map(item => {
        //   if(item.specifications.length != 0){
        //     item.specifications.map(data => {
        //       data["count"] = ++count;
        //     })
        //   }
        // });

        // console.log(this.props.productAttributeData);
        let count=0;
        resData.data.productAttributes.map((item , index) => {
          if(item.specifications.length != 0){
            item.specifications.map((data , zIndex) => {
              var Form = new Object();
              if (typeof this.props.productAttributeData[index+1].specifications[zIndex]==='undefined') {
                if (data.attributeTypeId<3) {
                  Form.value = "";
                } else {
                  Form.value = [];
                }
              } else {
                if (data.attributeTypeId === 5) {
                  // console.log(this.props.productAttributeData[index+1].specifications[zIndex].productAttributes[0]);
                  Form.value= this.props.productAttributeData[index+1].specifications[zIndex].productAttributes[0].items.length===0 ? [] : this.props.productAttributeData[index+1].specifications[zIndex].productAttributes[0].items.map(item => ({ value: item.code, label: item.title }));
                  // console.log(Form.value);
                } else if (data.attributeTypeId === 4) {
                  // console.log(this.props.productAttributeData[index+1].specifications[zIndex].productAttributes[0]);
                  Form.value= this.props.productAttributeData[index+1].specifications[zIndex].productAttributes[0].items.length===0 ? [] : this.props.productAttributeData[index+1].specifications[zIndex].productAttributes[0].items.map(item => ({ value: item.code, label: item.title }))[0];
                  // console.log(Form.value);
                } else if (data.attributeTypeId < 4) {
                  // console.log(this.props.productAttributeData[index+1].specifications[zIndex].productAttributes[0]);
                  Form.value= this.props.productAttributeData[index+1].specifications[zIndex].productAttributes[0].value ? this.props.productAttributeData[index+1].specifications[zIndex].productAttributes[0].value : [];
                  // console.log(Form.value);
                }
              }
              Form.valid= true;
              // Form.valid= data.isRequire ? false : true;
              Form.errorMessage= "";
              Form.touched= data.isRequire ? false : true;
              Form.validators= data.isRequire ? [required] : [];
              Form.code= data.code;
              Form.attributeTypeId= data.attributeTypeId;


              var Base = new Object();
              Base[data.title] = Form;
              this.setState({attributeForm: Object.assign(this.state.attributeForm, Base)})
              data["count"] = ++count;
            })
          }
        });
               
        this.setState({
          productAttributes: resData.data.productAttributes,
        });
      })
      // .catch((err) => {
      //   console.log(err);
      //   // this.setState({ functionButtonsLoading: true });
      // });
      .catch(this.catchError);
  };
  

  inputBlurHandler = (input) => {
    this.setState((prevState) => {
      return {
        attributeForm: {
          ...prevState.attributeForm,
          [input]: {
            ...prevState.attributeForm[input],
            touched: true,
          },
        },
      };
    });
  };

  inputSelectChangeHandler(event, selector) {
    if (Array.isArray(event)) {
      this.setState((prevState) => {
        let isValid = true;
        let errorMessage = "";
        for (const type in event.value) {
          isValid =
            isValid &&
            prevState.attributeForm[selector.name].validator(type.toString())
              .hasError;
          errorMessage =
            !isValid && errorMessage === ""
              ? prevState.attributeForm[selector.name].validator(type.toString())
                  .errorMessage
              : errorMessage;
        }
        const updatedForm = {
          ...prevState.attributeForm,
          [selector.name]: {
            ...prevState.attributeForm[selector.name],
            valid: isValid,
            value: event,
            errorMessage: errorMessage,
          },
        };
        let formIsValid = true;
        formIsValid = formIsValid && updatedForm[selector.name].valid;

        return {
          attributeForm: updatedForm,
          formIsValid: formIsValid,
        };
      });
    } else {
      this.setState((prevState) => {
        let isValid = true;
        let errorMessage = "";
        for (const validator of prevState.attributeForm[selector.name]
          .validators) {
          isValid = isValid && validator(event.value.toString()).hasError;
          errorMessage =
            !isValid && errorMessage === ""
              ? validator(event.value.toString()).errorMessage
              : errorMessage;
        }
        const updatedForm = {
          ...prevState.attributeForm,
          [selector.name]: {
            ...prevState.attributeForm[selector.name],
            valid: isValid,
            value: event,
            errorMessage: errorMessage,
          },
        };
        let formIsValid = true;
        for (const inputName in updatedForm) {
          formIsValid = formIsValid && updatedForm[inputName].valid;
        }

        return {
          attributeForm: updatedForm,
          formIsValid: formIsValid,
        };
      });
    }
  }

  inputChangeHandler = (input, value) => {
    this.setState((prevState) => {
      let isValid = true;
      let errorMessage = "";
      for (const validator of prevState.attributeForm[input].validators) {
        isValid = isValid && validator(value).hasError;
        errorMessage =
          !isValid && errorMessage === ""
            ? validator(value).errorMessage
            : errorMessage;
      }
      const updatedForm = {
        ...prevState.attributeForm,
        [input]: {
          ...prevState.attributeForm[input],
          valid: isValid,
          value: value,
          errorMessage: errorMessage,
        },
      };
      let formIsValid = true;
      for (const inputName in updatedForm) {
        formIsValid = formIsValid && updatedForm[inputName].valid;
      }

      return {
        attributeForm: updatedForm,
        formIsValid: formIsValid,
      };
    });
  }

  catchError = (error) => {
    this.props.errorCatcher.bind(this, error);
  };
 
  render() {
    return (
      <Fragment>
        <div className="mn-card__body  mn-card__body--content" id="stepAttributesContent">
            <form className="product-form" id="stepAttributesForm" noValidate="novalidate" data-select2-id="stepAttributesForm" onSubmit={e => { e.preventDefault(); }}> 


                <div className="mn-grid__row mn-grid__row--gap-lg">
                    <div className="mn-grid__col mn-grid__col--gap-attr mn-grid__col--flex-initial">
                        <h3 className="product-form__section-title product-form__section-title--dot">مشخصات فیزیکی کالا</h3>
                    </div>
                </div>
                
                <div className="mn-grid__row mn-grid__row--gap-lg">
                    <div className="mn-grid__col mn-grid__col--gap-attr mn-grid__col--flex-initial mn-grid__col--lg-6">
                        <div className="mn-grid__row mn-grid__row--gap-lg mn-grid__row--nowrap-sm">
                            <div className="mn-grid__col mn-grid__col--gap-attr mn-grid__col--flex-initial mn-grid__col--lg-8">
                                <label htmlFor="" className="uk-form-label">ابعاد (سانتی‌متر): <span className="uk-form-label__required"></span> 
                                </label>
                                <div className="mn-grid__row mn-grid__row--gap-small mn-grid__row--nowrap-sm">
                                    <div className=" mn-grid__col mn-grid__col--gap-small mn-grid__col--flex-initial mn-grid__col--xs-gap">
                                        <div
                                          className={[
                                            "field-wrapper",
                                            this.state.attributeForm["product_length"].errorMessage === ""
                                              ? ""
                                              : "has-error",
                                          ].join(" ")}
                                        >
                                            <label className="mn-content-input"> <span className="mn-content-input__text mn-content-input__text--overlay">طول</span>
                                                <input 
                                                className="mn-content-input__origin mn-content-input__origin--overlay " 
                                                type="text" 
                                                placeholder="" 
                                                id="product_length" 
                                                name="product_length"
                                                onChange={(e) =>
                                                this.inputChangeHandler(
                                                      e.target.id,
                                                      e.target.value
                                                    )
                                                  }
                                                onBlur={this.inputBlurHandler.bind(this, "product_length")}
                                                value={this.state.attributeForm["product_length"].value}
                                                valid={this.state.attributeForm["product_length"].valid}
                                                touched={this.state.attributeForm["product_length"].touched}
                                                />
                                                <div id="product_length-error" className="error error-msg">{this.state.attributeForm["product_length"].errorMessage}</div>
                                            </label>
                                        </div>
                                    </div>
                                    <div className=" mn-grid__col mn-grid__col--gap-small mn-grid__col--flex-initial mn-grid__col--xs-gap">
                                        <div
                                          className={[
                                            "field-wrapper",
                                            this.state.attributeForm["product_width"].errorMessage === ""
                                              ? ""
                                              : "has-error",
                                          ].join(" ")}
                                        >
                                            <label className="mn-content-input"> <span className="mn-content-input__text mn-content-input__text--overlay">عرض</span>
                                                <input 
                                                className="mn-content-input__origin mn-content-input__origin--overlay " 
                                                type="text" 
                                                placeholder="" 
                                                id="product_width" 
                                                name="product_width" 
                                                onChange={(e) =>
                                                this.inputChangeHandler(
                                                      e.target.id,
                                                      e.target.value
                                                    )
                                                  }
                                                onBlur={this.inputBlurHandler.bind(this, "product_width")}
                                                value={this.state.attributeForm["product_width"].value}
                                                valid={this.state.attributeForm["product_width"].valid}
                                                touched={this.state.attributeForm["product_width"].touched}
                                                />
                                                <div id="product_width-error" className="error error-msg">{this.state.attributeForm["product_width"].errorMessage}</div>
                                            </label>
                                        </div>
                                    </div>
                                    <div className=" mn-grid__col mn-grid__col--gap-small mn-grid__col--flex-initial mn-grid__col--xs-gap">
                                        <div
                                          className={[
                                            "field-wrapper",
                                            this.state.attributeForm["product_height"].errorMessage === ""
                                              ? ""
                                              : "has-error",
                                          ].join(" ")}
                                        >
                                            <label className="mn-content-input"> <span className="mn-content-input__text mn-content-input__text--overlay">ارتفاع</span>
                                              <input 
                                              className="mn-content-input__origin mn-content-input__origin--overlay" 
                                              type="text" 
                                              placeholder="" 
                                              id="product_height" 
                                              name="product_height" 
                                              onChange={(e) =>
                                              this.inputChangeHandler(
                                                    e.target.id,
                                                    e.target.value
                                                  )
                                                }
                                              onBlur={this.inputBlurHandler.bind(this, "product_height")}
                                              value={this.state.attributeForm["product_height"].value}
                                              valid={this.state.attributeForm["product_height"].valid}
                                              touched={this.state.attributeForm["product_height"].touched}
                                              />
                                              <div id="product_height-error" className="error error-msg">{this.state.attributeForm["product_height"].errorMessage}</div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mn-grid__col mn-grid__col--gap-attr mn-grid__col--flex-initial mn-grid__col--lg-4 mn-grid__col--xs-gap">
                                <label htmlFor="" className="uk-form-label">وزن (کیلوگرم): <span className="uk-form-label__required"></span>
                                </label>
                                <div
                                  className={[
                                    "field-wrapper",
                                    this.state.attributeForm["product_weight"].errorMessage === ""
                                      ? ""
                                      : "has-error",
                                  ].join(" ")}
                                >
                                    <label className="mn-content-input"> <span className="mn-content-input__text mn-content-input__text--overlay">وزن</span>
                                        <input 
                                        className="mn-content-input__origin mn-content-input__origin--overlay" 
                                        type="text" 
                                        placeholder="" 
                                        id="product_weight" 
                                        name="product_weight" 
                                        onChange={(e) =>
                                        this.inputChangeHandler(
                                              e.target.id,
                                              e.target.value
                                            )
                                          }
                                        onBlur={this.inputBlurHandler.bind(this, "product_weight")}
                                        value={this.state.attributeForm["product_weight"].value}
                                        valid={this.state.attributeForm["product_weight"].valid}
                                        touched={this.state.attributeForm["product_weight"].touched}
                                        />
                                        <div id="product_weight-error" className="error error-msg">{this.state.attributeForm["product_weight"].errorMessage}</div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.productAttributes.map((attributeGroup, index) => (
                  <Fragment>
                  <div className="mn-grid__row mn-grid__row--gap-lg">
                      <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial">
                          <h3 className="product-form__section-title product-form__section-title--dot">{attributeGroup.title}</h3>
                      </div>
                  </div>

                  {/* ///////////////////////////////////////////////////////////////////////////// */}
                  {attributeGroup.specifications &&
                  <div className="mn-grid__row mn-grid__row--gap-lg mn-grid__row--negative-gap-attr">
                      {attributeGroup.specifications.map((attribute, attributeIndex) => (
                      <Fragment>
                      {attribute.attributeTypeId===3 && (
                      
                      <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
                          <label className="uk-form-label uk-flex uk-flex-between">{attribute.title}{attribute.isRequire && <span className="uk-form-label__required"></span>}  <span className="uk-float-left uk-padding-medium-left">{attribute.unit}</span>
                          </label>
                          <div className={["field-wrapper",
                                  this.state.attributeForm[attribute.title].errorMessage === "" ? "" : "has-error",
                              ].join(" ")}>
                                
        
                                <Select
                                  name={attribute.title}
                                  control="input"
                                  // value={this.state.selectedType}
                                  options={origin}
                                  styles={colourStyles}
                                  theme={colourStyles.theme}
                                  onChange={this.inputSelectChangeHandler}
                                  onBlur={this.inputBlurHandler.bind(this, attribute.title)}
                                  value={origin.filter(item => (item.label === this.state.attributeForm[attribute.title].value))}
                                  valid={this.state.attributeForm[attribute.title].valid}
                                  touched={this.state.attributeForm[attribute.title].touched}
                                />
                              
                              
                              <div id={2} className="error error-msg">
                                  {this.state.attributeForm[attribute.title].errorMessage}
                              </div>
                          </div>
                          <div></div>
                      </div>
                      )
                      }

                      {attribute.attributeTypeId===4 && (
                      
                      <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
                          <label className="uk-form-label uk-flex uk-flex-between">{attribute.title}{attribute.isRequire && <span className="uk-form-label__required"></span>}  <span className="uk-float-left uk-padding-medium-left">{attribute.unit}</span>
                          </label>
                          <div className={["field-wrapper",
                                  this.state.attributeForm[attribute.title].errorMessage === "" ? "" : "has-error",
                              ].join(" ")}>      
                                <Select
                                  name={attribute.title}
                                  control="input"
                                  // value={this.state.selectedType}
                                  options={attribute.items.map(item => ({ value: item.code, label: item.title }))}
                                  styles={colourStyles}
                                  theme={colourStyles.theme}
                                  onChange={this.inputSelectChangeHandler}
                                  onBlur={this.inputBlurHandler.bind(this, attribute.title)}
                                  value={this.state.attributeForm[attribute.title].value}
                                  valid={this.state.attributeForm[attribute.title].valid}
                                  touched={this.state.attributeForm[attribute.title].touched}
                                />
                              
                              
                              <div id={2} className="error error-msg">
                                  {this.state.attributeForm[attribute.title].errorMessage}
                              </div>
                          </div>
                          <div></div>
                      </div>
                      )
                      }

                      {attribute.attributeTypeId===5 &&
                      <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-12">
                          <label className="uk-form-label uk-flex uk-flex-between"> {attribute.title} {attribute.isRequire && <span className="uk-form-label__required"></span>}  <span className="uk-float-left uk-padding-medium-left">{attribute.unit}</span>
                          </label>
                          <div className={["field-wrapper",
                                  this.state.attributeForm[attribute.title].errorMessage === "" ? "" : "has-error",
                              ].join(" ")}>
                                
                                <Select
                                  name={attribute.title}
                                  control="input"
                                  // value={this.state.selectedType}
                                  options={attribute.items.map(item => ({ value: item.code, label: item.title }))}
                                  isMulti
                                  styles={colourStyles}
                                  theme={colourStyles.theme}
                                  onChange={this.inputSelectChangeHandler}
                                  onBlur={this.inputBlurHandler.bind(this, attribute.title)}
                                  value={this.state.attributeForm[attribute.title].value}
                                  valid={this.state.attributeForm[attribute.title].valid}
                                  touched={this.state.attributeForm[attribute.title].touched}
                                />
                              
                              
                              <div id={2} className="error error-msg">
                                  {this.state.attributeForm[attribute.title].errorMessage}
                              </div>
                          </div>
                          <div></div>
                      </div>
                      }
                      {attribute.attributeTypeId===2 &&                  
                      <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-12">
                          <label className="uk-form-label uk-flex uk-flex-between">{attribute.title} {attribute.isRequire && <span className="uk-form-label__required"></span>} <span className="uk-float-left uk-padding-medium-left">{attribute.unit}</span>
                          </label>
                          <div className={["field-wrapper",
                                  this.state.attributeForm[attribute.title].errorMessage === "" ? "" : "has-error",
                              ].join(" ")}>
                              <textarea className="uk-textarea uk-textarea--attr" 
                              id={attribute.title}
                              type="textarea"
                              name={attribute.title}
                              onChange={(e) =>
                                  this.inputChangeHandler(
                                    e.target.id,
                                    e.target.value
                                  )
                                }
                              onBlur={this.inputBlurHandler.bind(this, attribute.title)}
                              value={this.state.attributeForm[attribute.title].value}
                              valid={this.state.attributeForm[attribute.title].valid}
                              touched={this.state.attributeForm[attribute.title].touched}
                              ></textarea>
                              <div id={2} className="error error-msg">
                                  {this.state.attributeForm[attribute.title].errorMessage}
                              </div>
                          </div>
                          <div></div>
                      </div>
                      }
                      {attribute.attributeTypeId===1 &&                  
                      <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
                          <label className="uk-form-label uk-flex uk-flex-between">{attribute.title} {attribute.isRequire && <span className="uk-form-label__required"></span>} <span className="uk-float-left uk-padding-medium-left">{attribute.unit}</span>
                          </label>
                          <div className={["field-wrapper",
                                  this.state.attributeForm[attribute.title].errorMessage === "" ? "" : "has-error",
                              ].join(" ")}>
                            <input  className="c-content-input__origin"                            
                              id={attribute.title}
                              type="text"
                              name={attribute.title}
                              onChange={(e) =>
                                  this.inputChangeHandler(
                                    e.target.id,
                                    e.target.value
                                  )
                                }
                              onBlur={this.inputBlurHandler.bind(this, attribute.title)}
                              value={this.state.attributeForm[attribute.title].value}
                              valid={this.state.attributeForm[attribute.title].valid}
                              touched={this.state.attributeForm[attribute.title].touched}
                              ></input>
                              <div id={2} className="error error-msg">
                                  {this.state.attributeForm[attribute.title].errorMessage}
                              </div>
                          </div>
                          <div></div>
                      </div>
                      }
                      </Fragment>
                      ))
                      }
                  </div>}
                  </Fragment>
                ))
                }
                {/* ///////////////////////////////////////////////////////////////////////////// */}

                {/* <div className="mn-content-accordion__step-controls mn-content-accordion__step-controls--spacer">
                    <button type="button" className="mn-ui-btn mn-ui-btn--next mr-a" id="attributesStepNext" onClick={this.productAttributeFormHandler.bind(this)}>
                        ادامه دادن
                    </button>
                </div> */}
            </form>
        </div>
      </Fragment>
    );
  }
}

export default ProductAttribute;
